export default __webpack_public_path__ + "static/media/plus~BxFyHBBS.9bc816bb.svg";